import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable()
export class GetUserService {

  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) { }

  getUser(userId: string, activeUsersOnly : boolean) {
    let sectionId = this.common.getSelectedSection().sectionId;

    // this.storeAuth.getSection().subscribe((v) => {
    //   if (!v) {
    //     this.sectionId = localStorage.getItem('gokuri.sectionId');
    //   } else {
    //     this.sectionId = v;
    //   }
    // });

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    this.headers = this.headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    var params = new HttpParams();

    if (activeUsersOnly){
      params = params.set("activeUsersOnly", "true");
    }
    else{
      params = params.set("activeUsersOnly", "false");
    }

    return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/users/${userId}`, { headers: this.headers, params : params });
  }
}
